import { ArrowDown } from "lucide-react";
import clsx from "clsx";

interface FunnelChartProps {
  funnel: {
    inquiryToQuoted: number;
    quotedToConfirmed: number;
    confirmedToPaid: number;
    overallConversion: number;
  };
  cancellationRate: number;
}

const STAGES = [
  { key: "inquiryToQuoted", label: "Poptávka → Naceneno", from: "Poptávka", to: "Naceneno" },
  { key: "quotedToConfirmed", label: "Naceneno → Potvrzeno", from: "Naceneno", to: "Potvrzeno" },
  { key: "confirmedToPaid", label: "Potvrzeno → Zaplaceno", from: "Potvrzeno", to: "Zaplaceno" },
];

export default function FunnelChart({ funnel, cancellationRate }: FunnelChartProps) {
  return (
    <div className="card">
      <h3 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
        Konverzní trychtýř
      </h3>

      <div className="space-y-3">
        {STAGES.map((stage, idx) => {
          const value = funnel[stage.key as keyof typeof funnel];
          return (
            <div key={stage.key}>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600 dark:text-gray-400">{stage.label}</span>
                <span
                  className={clsx(
                    "text-sm font-semibold",
                    value >= 80 ? "text-green-600" : value >= 60 ? "text-yellow-600" : "text-red-600"
                  )}
                >
                  {value}%
                </span>
              </div>
              <div className="mt-1 h-2 w-full rounded-full bg-gray-200 dark:bg-gray-700">
                <div
                  className={clsx(
                    "h-full rounded-full transition-all",
                    value >= 80 ? "bg-green-500" : value >= 60 ? "bg-yellow-500" : "bg-red-500"
                  )}
                  style={{ width: `${value}%` }}
                />
              </div>
              {idx < STAGES.length - 1 && (
                <div className="flex justify-center py-1">
                  <ArrowDown className="h-4 w-4 text-gray-400" />
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 border-t border-gray-200 pt-4 dark:border-gray-700">
        <div className="text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">Celková konverze</p>
          <p className="mt-1 text-2xl font-bold text-primary-600 dark:text-primary-400">
            {funnel.overallConversion}%
          </p>
        </div>
        <div className="text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">Míra storna</p>
          <p
            className={clsx(
              "mt-1 text-2xl font-bold",
              cancellationRate <= 5 ? "text-green-600" : cancellationRate <= 10 ? "text-yellow-600" : "text-red-600"
            )}
          >
            {cancellationRate}%
          </p>
        </div>
      </div>
    </div>
  );
}
